import { useEntryStore } from "@/store/entry.store";
import { PlayIcon } from "@roman/shared/components/Icons";
import { useNavigate } from "react-router-dom";

export const PlayerDetailButton = ({
  id,
  selectedPlayers,
  roundId,
}: {
  id: string;
  selectedPlayers: string[];
  roundId: string;
}) => {
  const navigate = useNavigate();
  const setPlayerIds = useEntryStore((state) => state.setPlayerIds);

  const handlePlayerDetail = () => {
    if (selectedPlayers.length) {
      setPlayerIds(selectedPlayers);
    }

    navigate(`/player-detail/${id}`, { state: { roundId } });
  };

  return (
    <button
      type="button"
      className="py-[3px] pl-1.5 pr-1 mt-1 space-x-0.5 flex justify-between items-center border-[1px] rounded-full bg-white border-primary w-fit"
      onClick={handlePlayerDetail}
    >
      <span className="text-[10px] leading-[9px] text-primary font-medium ">選手詳細</span>

      <div>
        <PlayIcon className="text-primary w-[9px] h-[9px]" />
      </div>
    </button>
  );
};
